import * as React from 'react'

import { NavigationRoutesFn } from 'modules/core/lib/react-router'

import { getSettingPageMeta } from 'modules/settings/lib/getSettingPageMeta'

const RootPage = React.lazy(() => import('modules/external_users/pages/settings/RootPage'))
const ExternalsPage = React.lazy(
  () => import('modules/external_users/pages/settings/ExternalsPage')
)

const settingsRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.settings.externals.path,
      element: <RootPage />,
      children: [
        {
          path: '',
          handle: {
            responsive: true,
            meta: () => {
              return getSettingPageMeta(navigation, 'external_users')
            },
          },
          element: <ExternalsPage />,
        },
      ],
    },
  ]
}

export default settingsRoutes
